export const formatBackendTag = (tag: string) =>
  tag
    .replace('kip-backend-v2-', '')
    .replace(/(T..)/, (x) => `${x.replace('T', '_')}:`)
    .replace('Z', '_Z');
